import { fetchCustomerList } from '#/api/crmMgmt/customer/fetchList';

export function mapCustomerRowsToSelectOptions(rows = []) {
  return rows.map((row) => ({
    value: row.id,
    label: [row.code, row.name].filter(Boolean).join(' - ') || String(row.id),
  }));
}

/** 編輯時若客戶已停用／不在 ACTIVE select，併入選項以免空白。 */
export function mergeCustomerSelectOption(options = [], customer) {
  if (!customer?.id) {
    return options;
  }
  if (options.some((option) => option.value === customer.id)) {
    return options;
  }
  return [
    ...options,
    {
      value: customer.id,
      label: [customer.code, customer.name].filter(Boolean).join(' - ') || String(customer.id),
    },
  ];
}

/**
 * ACTIVE 客戶 select options（客戶訂單 Create 等）。
 * 使用 lookupQueryKey('customerSelect')。
 */
export async function fetchCustomerSelectOptions() {
  const { data } = await fetchCustomerList({
    page: 1,
    pageSize: 200,
    keyword: '',
    sort: [],
    filters: { status: 'ACTIVE' },
  });

  return mapCustomerRowsToSelectOptions(data ?? []);
}
